import { IconStorefront } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { Affiliates as AffiliatesType } from 'typings'
import { useDrawerState, useFormStateContext } from '../../../..'
import { useConditions } from '../useConditions'
import { Editor } from './Editor'
import { AffiliatesView } from './View'
import { messages } from './messages'

interface Props {
  name: string
}

export function Affiliates(props: Props) {
  const { name } = props
  const { $t } = useIntl()

  const { form } = useFormStateContext()
  const config: AffiliatesType = useWatch({ form, name })

  const editorState = useDrawerState()

  useConditions({
    name,
    onEdit: editorState.show,
    label: $t(messages.title),
    icon: <IconStorefront />,
  })

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (values: AffiliatesType | undefined) =>
    form.setValue(name, values)

  return (
    <>
      <AffiliatesView
        config={config}
        onEdit={editorState.show}
        onRemove={handleRemove}
      />
      <Editor state={editorState} initialConfig={config} onSave={handleSave} />
    </>
  )
}
